document.addEventListener("click", (e) => {
  const card = e.target.closest(".card-wrapper, .product-card-wrapper");
  if (!card) return;

  // Ne jamais intercepter les clics sur éléments interactifs
  if (e.target.closest("a, button, .hb-fav")) return;

  const link = card.querySelector("a.full-unstyled-link");
  if (link && link.href) window.location.href = link.href;
});
